import { Components } from '@ionic/core';
import { IonIcon, IonItem, IonLabel, IonText } from '@ionic/react';
import { closeOutline, openOutline } from 'ionicons/icons';
import { ReactElement } from 'react';

interface IonFormExternalPickerProps {
  selectedName: string | undefined;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  onClick: () => void;
  onUnset?: () => void;
  ionItemProps?: Partial<Components.IonItem>;
}

const IonFormExternalPicker = (
  props: IonFormExternalPickerProps
): ReactElement => {
  const {
    selectedName,
    label,
    placeholder,
    disabled,
    onClick,
    onUnset,
    ionItemProps,
  } = props;

  return (
    <IonItem
      lines="full"
      className="transparent-background parameter-selected"
      href=""
      disabled={disabled}
      onClick={(e) => {
        e.preventDefault();
        onClick();
      }}
      detail={false}
      {...ionItemProps}
    >
      {label && (
        <IonLabel>
          <span>{label}</span>
        </IonLabel>
      )}
      <IonText
        className="ion-margin-end"
        color={selectedName ? undefined : 'medium'}
      >
        {selectedName ?? placeholder}
      </IonText>
      {selectedName ? (
        <IonIcon
          slot="end"
          icon={closeOutline}
          color={'medium'}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            if (typeof onUnset === 'function') {
              onUnset();
            }
          }}
        />
      ) : (
        <IonIcon slot="end" icon={openOutline} color={'medium'} />
      )}
    </IonItem>
  );
};

export { IonFormExternalPicker };
